import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Assuming you're using react-router for routing
import supabase from '../supabase'; // Adjust the import path as necessary
import { Box, Button, TextField, Typography, Alert } from '@mui/material';
import Card from '@mui/material/Card';
import MDBoxRoot from './MDBox/MDBoxRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';
import MDButtonRoot from './MDButton/MDButtonRoot';
import MDInput from './MDInput/MDInputRoot';

const ResetPassword2: React.FC = () => {
  //const location = useLocation();
  //const history = useHistory();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  // Extract the access token from the URL query parameters
  //const query = new URLSearchParams(location.search);
  //const accessToken = query.get('access_token');

  /*
  useEffect(() => {
    if (!accessToken) {
      setError('Invalid or missing reset token.');
    }
  }, [accessToken]);*/

  const handleResetPassword = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      setLoading(false);
      return;
    }

    if (password) {
      const { error } = await supabase.auth.updateUser({
        password: password
      });

      setLoading(false);

      if (error) {
        setError(error.message);
      } else {
        setSuccess('Password updated successfully! You can now log in with your new password.');
        // Optionally redirect the user to the login page after a short delay
        setTimeout(() => navigate('/'), 3000);
      }
    } else {
      setError('Missing access token.');
      setLoading(false);
    }
  };

  return (
    <MDBoxRoot sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <MDTypographyRoot variant="h5" mb={2} align="center">
        Reset Password
      </MDTypographyRoot>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      {!success &&
        <>
          <MDInput
            label="New Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            sx={{ mb: 2 }}
          />
          <MDInput

            label="Confirm New Password"
            type="password"
            variant="outlined"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={loading}
            sx={{ mb: 2 }}
          />
          <MDButtonRoot
            ownerState={{
              size: "medium",
              color: "primary",
              variant:"contained",
              textTransform:"uppercase",
          }}

            fullWidth
            onClick={handleResetPassword}
            disabled={loading || !password || !confirmPassword}
          >
            {loading ? 'Updating password...' : 'Update Password'}
          </MDButtonRoot>
        </>}
    </MDBoxRoot>

  );
};

export default ResetPassword2;
